var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5552 12.6081L17.8155 16.8662C18.0615 17.1313 18.0615 17.5412 17.8155 17.8063C17.689 17.9282 17.5209 17.9974 17.3452 17.9998C17.1685 18.0026 16.9984 17.9326 16.8749 17.8063L12.6146 13.5482C9.46722 16.1905 4.79597 15.8864 2.01825 12.8582C-0.759463 9.82996 -0.657954 5.15233 2.24852 2.24736C5.15499 -0.657614 9.83504 -0.759071 12.8648 2.01721C15.8946 4.7935 16.1989 9.46233 13.5552 12.6081ZM1.82377 10.1051C2.8054 12.4737 5.11795 14.0181 7.68308 14.0181C11.1841 14.0143 14.0213 11.1786 14.0252 7.67932C14.0252 5.11551 12.48 2.80416 10.1101 1.82303C7.74022 0.841904 5.01238 1.38422 3.19856 3.19711C1.38474 5.00999 0.842135 7.73643 1.82377 10.1051Z",
    fill: "#F25500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeSearchIcon);
export default __webpack_public_path__ + "static/media/orange_search_icon.74c17976ca2839a9ae7b86addf562533.svg";
export { ForwardRef as ReactComponent };